// Standard relative-luminance heuristic (WCAG-ish, good enough for label/status chip contrast) —
// used instead of a hardcoded `text-white` class since chip backgrounds are arbitrary,
// user-picked colors, not a light/dark theme token (see CLAUDE.md Styling conventions).
export function contrastTextColor(hex?: string): string {
  if (!hex) return '#ffffff';
  const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!match) return '#ffffff';
  const [r, g, b] = match.slice(1).map((c) => parseInt(c, 16) / 255);
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance > 0.6 ? '#1f2937' : '#ffffff';
}
